
import React from "react";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import SummaryCards from "./SummaryCards";
import UserMetricsChart from "./UserMetricsChart";
import UserDistributionChart from "./UserDistributionChart";
import CountryDistributionChart from "./CountryDistributionChart";
import LanguageDistributionChart from "./LanguageDistributionChart";
import TherapistConnectionsTable from "./TherapistConnectionsTable";

interface DashboardContentProps {
  analyticsData: any;
}

export const DashboardContent = ({ analyticsData }: DashboardContentProps) => {
  // Prepare data for UserMetricsChart
  const userMetrics = [
    { name: "Clients", value: analyticsData.clientCount || 0 },
    { name: "Therapists", value: analyticsData.therapistCount || 0 },
    { name: "Journal Entries", value: analyticsData.journalCount || 0 },
    { name: "File Uploads", value: analyticsData.totalUploads || 0 },
    { name: "Storage Used (MB)", value: analyticsData.totalStorageMB || 0 }
  ];
  
  // Prepare data for UserDistributionChart
  const userDistribution = [
    { name: "Clients", value: analyticsData.clientCount || 0 },
    { name: "Therapists", value: analyticsData.therapistCount || 0 },
    { name: "Admins", value: analyticsData.adminCount || 0 },
    { name: "Unassigned", value: analyticsData.unassignedCount || 0 }
  ];
  
  return (
    <div className="grid grid-cols-1 gap-6">
      <SummaryCards 
        userCount={analyticsData.userCount || 0}
        clientCount={analyticsData.clientCount || 0}
        therapistCount={analyticsData.therapistCount || 0}
        adminCount={analyticsData.adminCount || 0}
        unassignedCount={analyticsData.unassignedCount || 0}
        journalCount={analyticsData.journalCount || 0}
        averageJournalsPerClient={analyticsData.averageJournalsPerClient || 0}
        connectionRequests={analyticsData.connectionRequests || 0}
        clientToTherapistRatio={analyticsData.clientToTherapistRatio || 0}
        pageHits={analyticsData.pageHits || 0}
        totalUploads={analyticsData.totalUploads || 0}
        totalStorageMB={analyticsData.totalStorageMB || 0}
        averageUploadsPerClient={analyticsData.averageUploadsPerClient || 0}
        averageStoragePerClientMB={analyticsData.averageStoragePerClientMB || 0}
      />
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <UserMetricsChart userMetrics={userMetrics} />
        <UserDistributionChart userDistribution={userDistribution} />
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <CountryDistributionChart countryDistribution={analyticsData.countryDistribution || []} />
        <LanguageDistributionChart languageDistribution={analyticsData.languageDistribution || []} />
      </div>
      <TherapistConnectionsTable therapistsWithConnections={analyticsData.therapistsWithConnections || []} />
    </div>
  );
};

export default DashboardContent;
